import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import HomePage from "./pages/HomePage.jsx";
import ProtectedAdminDashboard from "./pages/ProtectedAdminDashboard.jsx";
import MentionsLegales from "./pages/MentionsLegales.jsx";
import PolitiqueConfidentialite from "./pages/PolitiqueConfidentialite.jsx";
import Disclaimer from "./pages/Disclaimer.jsx";
import SitesParis from "./pages/SitesParis.jsx";
import Bonus from "./pages/Bonus.jsx";
import Guides from "./pages/Guides.jsx";
import Pronostics from "./pages/Pronostics.jsx";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/admin" element={<ProtectedAdminDashboard />} />
          <Route path="/mentions-legales" element={<MentionsLegales />} />
          <Route path="/politique-confidentialite" element={<PolitiqueConfidentialite />} />
          <Route path="/disclaimer" element={<Disclaimer />} />
          <Route path="/sites-paris" element={<SitesParis />} />
          <Route path="/bonus" element={<Bonus />} />
          <Route path="/guides" element={<Guides />} />
          <Route path="/pronostics" element={<Pronostics />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;